import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FILTERS } from '../../constants/FiltersConstants';
import { ONBOARDING_FORECAST_CATEGORY_TAB } from '../../constants/TourConstants';
import { DEAL_STAGE, FORECAST_CATEGORY } from '../../constants/DealGroupingType';
import { setFilter } from '../../actions/FiltersActions';
import { getDealGroupingTypeFilter } from '../../selectors/filtersSelectors';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DealGroupingTypeFilter = () => {
  const dispatch = useDispatch();
  const dealGroupingType = useSelector(getDealGroupingTypeFilter);
  const handleDealGroupingTypeChange = useCallback(value => {
    void dispatch(setFilter({
      filter: FILTERS.DEAL_GROUPING_TYPE,
      value
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    "data-tour-step-key": ONBOARDING_FORECAST_CATEGORY_TAB,
    className: "m-right-4",
    children: [/*#__PURE__*/_jsx(UIButton
    // @ts-expect-error active is a hidden prop
    , {
      active: dealGroupingType === DEAL_STAGE,
      "data-test-id": "deal-stage-view",
      size: "medium",
      use: "tertiary-light",
      onClick: () => {
        if (dealGroupingType === FORECAST_CATEGORY) {
          handleDealGroupingTypeChange(DEAL_STAGE);
        }
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tabs.dealStage.title"
      })
    }), /*#__PURE__*/_jsx(UIButton
    // @ts-expect-error active is a hidden prop
    , {
      active: dealGroupingType === FORECAST_CATEGORY,
      "data-test-id": "forecast-category-view",
      size: "medium",
      use: "tertiary-light",
      onClick: () => {
        if (dealGroupingType === DEAL_STAGE) {
          handleDealGroupingTypeChange(FORECAST_CATEGORY);
        }
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tabs.forecastCategory.title"
      })
    })]
  });
};
export default DealGroupingTypeFilter;